module.exports = __webpack_public_path__ + "img/card2-image.270387ce.svg";